const hybridResourceTypes = ['cluster', 'server_group', 'server']
const rtfResourceTypes = ['mc']

export const isHybrid = (resourceType: string): boolean => hybridResourceTypes.indexOf(resourceType.toLowerCase()) > -1

export const isRTF = (resourceType: string): boolean => rtfResourceTypes.indexOf(resourceType.toLowerCase()) > -1

export const isHybridOrRTF = (resourceType: string): boolean => isHybrid(resourceType) || isRTF(resourceType)
